import React from 'react';
import moment from 'moment';
import {
  prefilledFetch,
  handleFetchInitialResponse,
  handleFetchError,
} from '../util/helperFunctions';
import { Box } from 'bloomer/lib/elements/Box';
import Conditional from './Conditional';
import { Button } from 'bloomer/lib/elements/Button';
import SingleEnrichmentDisplay from './SingleEnrichmentDisplay';

interface PropTypes {
  data: Comment;
}

class DisplayComment extends React.Component<PropTypes> {
  state = {
    loading: false,
    context: undefined,
  };

  fetchEnrichSession = () => {
    this.setState({
      loading: true,
    });
    prefilledFetch({
      method: 'GET',
      endpoint: `/enrichmentData/${this.props.data.enrichmentSession}`,
      body: {},
    })
      .then(handleFetchInitialResponse)
      .then((json: Enrichment) => {
        this.setState({
          loading: false,
          context: json,
        });
      })
      .catch((err: Error) => {
        this.setState({
          loading: false,
        });
        handleFetchError(err);
      });
  };
  render() {
    const { timeReturned, commentEmoticon, comment } = this.props.data;
    const { context } = this.state;
    return (
      <Box>
        <Conditional check={commentEmoticon !== undefined}>
          <p>
            <span className="bold">Enrichment Session Rating:</span>
            {commentEmoticon}
          </p>
        </Conditional>
        <div>
          <p className="clearfix">
            <span className="bold">Comment:</span>
            <span style={{ float: 'right' }}>
              {moment(timeReturned).format('h:mma YYYY/MM/DD')}
            </span>
          </p>

          <blockquote>
            <p>{comment}</p>
          </blockquote>
        </div>
        <Conditional
          check={context !== undefined}
          alt={
            <Button
              isLoading={this.state.loading}
              onClick={this.fetchEnrichSession}
            >
              Find Context
            </Button>
          }
        >
          <SingleEnrichmentDisplay context={context} />
        </Conditional>
      </Box>
    );
  }
}
export default DisplayComment;
